var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.626 17.798c.133 0 .254.058.349.156a.497.497 0 0 1 .12.372c0 .045-.355 4.538-.558 6.43-.127 1.16-.875 1.865-1.997 1.884-.863.02-1.707.026-2.537.026-.882 0-1.745-.006-2.582-.026-1.084-.026-1.833-.743-1.954-1.884-.209-1.898-.557-6.385-.564-6.43a.527.527 0 0 1 .127-.372.471.471 0 0 1 .349-.156h9.247Zm-3.25-4.465c.59 0 1.116.411 1.269.998l.109.487a.854.854 0 0 0 .827.677h1.944c.26 0 .475.215.475.49v.253c0 .267-.216.489-.475.489h-11.05a.487.487 0 0 1-.475-.49v-.253c0-.274.216-.489.476-.489h1.944c.395 0 .738-.28.827-.677l.102-.454c.158-.62.679-1.031 1.274-1.031h2.753Z",
    fill: "#EC2B00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.3260c73b56d35e116f2b453ce8475f26.svg";
export { ForwardRef as ReactComponent };